import { render, staticRenderFns } from "./VatDataFormUpload.vue?vue&type=template&id=05fb4672&"
import script from "./VatDataFormUpload.vue?vue&type=script&lang=js&"
export * from "./VatDataFormUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports